(() => {
  const key = 'rr-grid-density-desktop';
  const slideshowKey = 'rr-slideshow-preferences';
  let slideshow = { enabled: true, duration: 16000 };
  try {
    const saved = JSON.parse(localStorage.getItem(slideshowKey));
    if (typeof saved?.duration === 'number' && saved.duration >= 4000 && saved.duration <= 16000) slideshow.duration = Math.round(saved.duration / 1000) * 1000;
  } catch {}
  window.rrSlideshowPreferences = slideshow;
  function saveSlideshow(animate = false) {
    try { localStorage.setItem(slideshowKey, JSON.stringify(slideshow)); } catch {}
    document.querySelectorAll('rr-grid-density').forEach(control => control.syncSlideshow(animate));
    document.dispatchEvent(new CustomEvent('rr:slideshow-preferences-change'));
  }
  const accordionKey = 'rr-grid-density-accordion-open';
  const desktop = matchMedia('(min-width: 1000px)');
  const tablet = matchMedia('(min-width: 700px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fullscreen = matchMedia('(display-mode: fullscreen)');
  let fullscreenMode = fullscreen.matches;
  let fullscreenPending = false;
  let fullscreenTimer;
  const root = document.documentElement;
  const listsSelector = ':is(.shopify-section--main-collection, .rr-search--page) .collection__main > .product-list';
  const valid = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 6;
  let count = valid(root.dataset.rrGridDensity) ? Number(root.dataset.rrGridDensity) : 3;
  let manual = root.dataset.rrGridDensityManual === 'true';
  try { manual ||= valid(localStorage.getItem(key)); } catch {}
  let layoutPending = false;
  const viewportMode = () => desktop.matches ? 'desktop' : tablet.matches ? 'tablet' : 'mobile';
  let committedMode = viewportMode();
  const layoutSnapshots = new Map();
  const heldLayout = new Map();
  function rememberLayout() {
    if (heldLayout.size || committedMode !== viewportMode()) return;
    layoutSnapshots.clear();
    for (const list of document.querySelectorAll(listsSelector)) {
      const style = getComputedStyle(list);
      const tracks = style.gridTemplateColumns.split(/\s+/).filter(Boolean).length;
      if (!tracks || style.gridTemplateColumns === 'none') continue;
      const entries = [[list, { 'grid-template-columns': `repeat(${tracks}, minmax(0, 1fr))`, 'grid-auto-flow': style.gridAutoFlow }]];
      for (const card of list.querySelectorAll(':scope > product-card')) {
        const cardStyle = getComputedStyle(card);
        entries.push([card, { 'grid-column': `${cardStyle.gridColumnStart} / ${cardStyle.gridColumnEnd}` }]);
      }
      layoutSnapshots.set(list, entries);
    }
  }
  function freezeLayout() {
    for (const [list, entries] of layoutSnapshots) {
      if (!list.isConnected) continue;
      for (const [element, properties] of entries) {
        if (heldLayout.has(element)) continue;
        const original = {};
        for (const [property, value] of Object.entries(properties)) {
          original[property] = [element.style.getPropertyValue(property), element.style.getPropertyPriority(property)];
          element.style.setProperty(property, value, 'important');
        }
        heldLayout.set(element, original);
      }
    }
  }
  function releaseLayout() {
    for (const [element, properties] of heldLayout) {
      for (const [property, [value, priority]] of Object.entries(properties)) {
        if (value) element.style.setProperty(property, value, priority);
        else element.style.removeProperty(property);
      }
    }
    heldLayout.clear();
  }
  function automaticCount() {
    const cutoff = Math.ceil(window.innerWidth / 3 + 415);
    return window.innerWidth < 1000 ? 3 : count === 4
      ? (window.innerHeight >= cutoff + 25 ? 3 : 4)
      : (window.innerHeight <= cutoff ? 4 : 3);
  }
  function updateAutoDensity(responsiveChange = false) {
    if (fullscreen.matches !== fullscreenMode) {
      fullscreenMode = fullscreen.matches;
      fullscreenPending = true;
    }
    if (fullscreenPending && !reduced.matches) {
      if (responsiveChange) freezeLayout();
      clearTimeout(fullscreenTimer);
      fullscreenTimer = setTimeout(() => {
        fullscreenPending = false;
        updateAutoDensity(committedMode !== viewportMode());
      }, 600);
      return;
    }
    if (manual || !desktop.matches) {
      if (responsiveChange) select(count, false, true);
      return;
    }
    select(automaticCount(), false, responsiveChange);
  }
  const originalSizes = new WeakMap();
  const watched = new Set();
  let revision = 0;
  const heldOpacity = new Map();
  function holdOpacity(list, opacity) {
    if (!heldOpacity.has(list)) heldOpacity.set(list, { value: list.style.getPropertyValue('opacity'), priority: list.style.getPropertyPriority('opacity'), willChange: list.style.getPropertyValue('will-change'), willChangePriority: list.style.getPropertyPriority('will-change') });
    list.style.setProperty('will-change', 'opacity');
    list.style.setProperty('opacity', opacity);
  }
  function releaseOpacity() {
    for (const [list, original] of heldOpacity) {
      if (original.value) list.style.setProperty('opacity', original.value, original.priority);
      else list.style.removeProperty('opacity');
      if (original.willChange) list.style.setProperty('will-change', original.willChange, original.willChangePriority);
      else list.style.removeProperty('will-change');
    }
    heldOpacity.clear();
  }
  function fadeGrid(entries, target, duration, currentRevision) {
    const starts = entries.map(({ list, opacity }) => ({ list, opacity: Number(opacity) }));
    return new Promise(resolve => {
      let elapsed = 0;
      let previous;
      const tick = now => {
        if (currentRevision !== revision) { resolve(); return; }
        if (previous !== undefined) elapsed = Math.min(duration, elapsed + Math.min(32, now - previous));
        previous = now;
        const progress = elapsed / duration;
        const eased = (1 - Math.cos(Math.PI * progress)) / 2;
        for (const { list, opacity } of starts) holdOpacity(list, String(opacity + (target - opacity) * eased));
        if (elapsed < duration) requestAnimationFrame(tick);
        else resolve();
      };
      requestAnimationFrame(tick);
    });
  }
  let frame;
  function sizeImages() {
    cancelAnimationFrame(frame);
    frame = null;
    rememberLayout();
    // Complete each read phase before mutating any card. Drawer width animation
    // must not force a fresh page layout for every product in the collection.
    const cards = [];
    for (const list of document.querySelectorAll(listsSelector)) {
      if (!watched.has(list)) { watched.add(list); resize.observe(list); }
      cards.push(...list.querySelectorAll(':scope > product-card'));
    }
    const detailView = desktop.matches && root.dataset.rrGridDensity === '1';
    const reservations = cards.map(card => {
      if (detailView) return null;
      const info = card.querySelector('.product-card__info');
      return Math.ceil((info?.getBoundingClientRect().height || 0) + (parseFloat(getComputedStyle(card).rowGap) || 0)) + 'px';
    });
    cards.forEach((card, index) => {
      if (reservations[index] !== null && card.style.getPropertyValue('--rr-card-info-height') !== reservations[index]) card.style.setProperty('--rr-card-info-height', reservations[index]);
    });
    const widths = cards.map(card => Math.ceil(card.querySelector('.product-card__media')?.getBoundingClientRect().width || card.getBoundingClientRect().width));
    cards.forEach((card, index) => {
      for (const img of card.querySelectorAll('img.product-card__image')) {
        if (!originalSizes.has(img)) originalSizes.set(img, img.getAttribute('sizes'));
        const sizes = desktop.matches && widths[index] > 0 ? `${widths[index]}px` : originalSizes.get(img);
        if (sizes === null) img.removeAttribute('sizes');
        else if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
      }
    });
    for (const list of watched) if (!list.isConnected) { resize.unobserve(list); watched.delete(list); }
  }
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sizeImages); };
  const resize = new ResizeObserver(schedule);
  async function select(value, persist = true, responsiveChange = false) {
    if (!valid(value) || (!desktop.matches && !responsiveChange)) return;
    if (responsiveChange && !reduced.matches) freezeLayout();
    if (!persist && heldOpacity.size) {
      layoutPending = true;
      return;
    }
    // Selecting the current count also opts out of automatic resizing.
    if (persist) {
      manual = true;
      root.dataset.rrGridDensityManual = 'true';
      try { localStorage.setItem(key, String(value)); } catch {}
    }
    if (!responsiveChange && Number(value) === count && root.dataset.rrGridDensity === String(value)) return;
    const currentRevision = ++revision;
    count = Number(value);
    document.querySelectorAll('rr-grid-density').forEach(control => control.sync());
    const outgoing = [...document.querySelectorAll(listsSelector)].map(list => ({ list, opacity: getComputedStyle(list).opacity }));
    // Preserve the visible opacity before cancelling an interrupted timeline.
    outgoing.forEach(({ list, opacity }) => holdOpacity(list, opacity));
    if (!reduced.matches) {
      await fadeGrid(outgoing, 0, 160, currentRevision);
      if (currentRevision !== revision) return;
      const settingsMotions = [...document.querySelectorAll('rr-grid-density')]
        .map(control => control.settingsAnimation?.finished).filter(Boolean);
      await Promise.all(settingsMotions.map(motion => motion.catch(() => {})));
      if (currentRevision !== revision) return;
    }
    // Keep the grid hidden throughout reflow and Safari's animation handoff.
    if (!reduced.matches) outgoing.forEach(({ list }) => holdOpacity(list, '0'));
    const cards = [...document.querySelectorAll(`${listsSelector} > product-card`)];
    const headerBottom = document.querySelector('header')?.getBoundingClientRect().bottom || 0;
    const anchor = cards.find(card => card.hasAttribute('data-detail-active') && !card.inert) || cards.find(card => { const rect = card.getBoundingClientRect(); return rect.bottom > headerBottom && rect.top < innerHeight; });
    const top = anchor?.getBoundingClientRect().top;
    releaseLayout();
    committedMode = viewportMode();
    layoutPending = false;
    if (!persist && !manual && desktop.matches) count = automaticCount();
    root.dataset.rrGridDensity = String(count);
    document.querySelectorAll('rr-grid-density').forEach(control => control.sync());
    // Temporary return-from-product grid placements belong to the previous density.
    for (const card of cards) card.style.removeProperty('grid-column');
    document.dispatchEvent(new CustomEvent('rr:grid-density-change', { detail: { anchor: anchor?.getAttribute('handle') } }));
    sizeImages();
    const list = anchor?.closest('.product-list') || document.querySelector(listsSelector);
    if (list && !responsiveChange) {
      const galleryBottom = list.getBoundingClientRect().bottom + window.scrollY;
      const nextSection = list.closest('.shopify-section')?.nextElementSibling;
      const nextSectionTop = nextSection ? nextSection.getBoundingClientRect().top + window.scrollY : Infinity;
      // Keep about 300px below the gallery clear of the footer vignette,
      // stopping sooner if the next section would enter the viewport.
      const lowestScroll = Math.max(0, Math.min(galleryBottom + 300, nextSectionTop) - innerHeight);
      const anchoredScroll = window.scrollY + (anchor ? anchor.getBoundingClientRect().top - top : 0);
      window.scrollTo({ top: Math.max(0, Math.min(anchoredScroll, lowestScroll)), behavior: 'instant' });
    }
    if (!reduced.matches) {
      const incoming = [...document.querySelectorAll(listsSelector)];
      incoming.forEach(list => holdOpacity(list, '0'));
      // Allow layout observers and a hidden paint to settle before every fade-in.
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (currentRevision !== revision) return;
      await fadeGrid(incoming.map(list => ({ list, opacity: 0 })), 1, 200, currentRevision);
      if (currentRevision !== revision) return;
    }
    releaseOpacity();
    if (layoutPending) {
      layoutPending = false;
      document.dispatchEvent(new CustomEvent('rr:grid-density-change'));
      sizeImages();
      const responsivePending = committedMode !== viewportMode();
      if (!responsivePending) releaseLayout();
      updateAutoDensity(responsivePending);
    }
  }
  class GridDensity extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const details = this.querySelector('details');
      try {
        details.open = sessionStorage.getItem(accordionKey) === 'true';
        details.setAttribute('aria-expanded', String(details.open));
      } catch {}
      this.accordionObserver?.disconnect();
      this.accordionObserver = new MutationObserver(() => {
        try { sessionStorage.setItem(accordionKey, details.getAttribute('aria-expanded')); } catch {}
      });
      this.accordionObserver.observe(details, {attributes: true, attributeFilter: ['aria-expanded']});
      this.buttons = [...this.querySelectorAll('[data-density]')];
      this.group = this.querySelector('[role="radiogroup"]');
      this.number = this.querySelector('[data-density-current]');
      this.previous = this.querySelector('[data-density-previous]');
      this.label = this.querySelector('[data-density-label]');
      this.settings = this.querySelector('[data-slideshow-settings]');
      this.speedPanel = this.querySelector('[data-slideshow-speed]');
      this.speedRange = this.querySelector('[data-slideshow-range]');
      this.durationOutput = this.querySelector('[data-slideshow-duration]');
      this.durationNumber = this.querySelector('[data-duration-current]');
      this.durationPrevious = this.querySelector('[data-duration-previous]');
      for (const type of ['pointerdown', 'keydown']) {
        this.speedRange?.addEventListener(type, () => this.cancelSpeedAnimation(), options);
      }
      this.speedRange?.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary || this.speedRange.disabled) return;
        const range = this.speedRange;
        const rect = range.getBoundingClientRect();
        const rtl = getComputedStyle(range).direction === 'rtl';
        const fraction = Number(range.value) / 12;
        const thumbX = rect.left + 4.25 + (rtl ? 1 - fraction : fraction) * (rect.width - 8.5);
        if (Math.abs(event.clientX - thumbX) <= 9) return;
        event.preventDefault();
        range.focus({ preventScroll: true });
        range.setPointerCapture(event.pointerId);
        this.trackPointer = { id: event.pointerId, x: event.clientX };
        this.setTrackSpeed(event.clientX, true);
      }, options);
      this.speedRange?.addEventListener('pointermove', event => {
        if (this.trackPointer?.id !== event.pointerId || Math.abs(event.clientX - this.trackPointer.x) < 3) return;
        this.setTrackSpeed(event.clientX, false);
      }, options);
      for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) {
        this.speedRange?.addEventListener(type, () => { this.trackPointer = null; }, options);
      }
      this.speedRange?.addEventListener('input', event => {
        this.cancelSpeedAnimation();
        event.stopPropagation();
        const seconds = 16 - Number(this.speedRange.value);
        slideshow.duration = Math.round(seconds) * 1000;
        saveSlideshow();
      }, options);
      this.speedRange?.addEventListener('change', event => event.stopPropagation(), options);
      this.querySelectorAll('[data-slideshow-endpoint]').forEach(button => {
        button.addEventListener('click', event => {
          event.stopPropagation();
          if (this.speedRange.disabled) return;
          slideshow.duration = button.dataset.slideshowEndpoint === 'slow' ? 16000 : 4000;
          saveSlideshow(true);
        }, options);
      });
      this.sync(false);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-density]');
        if (button) { this.preview(null); select(button.dataset.density); }
      }, options);
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-density]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = Number(button.dataset.density);
        const next = event.key === 'Home' ? 1 : event.key === 'End' ? 6 : ((current - 1 + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : 5)) % 6) + 1;
        this.preview(null); select(next); this.buttons[next - 1].focus({ preventScroll: true });
      }, options);
      this.group.addEventListener('pointerover', event => {
        const button = event.target.closest('[data-density]');
        if (button && event.pointerType !== 'touch') this.preview(Number(button.dataset.density));
      }, options);
      this.group.addEventListener('pointerleave', () => this.preview(null), options);
      // Use native drawer accordion motion; finish immediately for reduced motion.
      this.querySelector('summary').addEventListener('click', event => {
        if (!reduced.matches) return;
        event.preventDefault(); event.stopImmediatePropagation();
        const details = this.querySelector('details');
        details.open = !details.open; details.setAttribute('aria-expanded', String(details.open));
      }, { ...options, capture: true });
    }
    disconnectedCallback() { this.settingsAnimation?.cancel(); this.settingsVisible = undefined; this.cancelSpeedAnimation(); this.abort?.abort(); this.accordionObserver?.disconnect(); }
    preview(value) {
      this.group.toggleAttribute('data-preview', value !== null);
      this.buttons.forEach(button => button.dataset.previewFilled = String(Number(button.dataset.density) <= value));
    }
    crossfadeText(previous, current, value, animate) {
      if (current.textContent === value) return;
      [previous, current].forEach(node => node.getAnimations().forEach(animation => animation.cancel()));
      previous.textContent = current.textContent;
      current.textContent = value;
      if (animate && !reduced.matches) {
        const timing = { duration: 200, easing: 'ease-in-out' };
        previous.animate({ opacity: [1, 0] }, timing);
        current.animate({ opacity: [0, 1] }, timing);
      }
    }
    setTrackSpeed(clientX, animate) {
      const rect = this.speedRange.getBoundingClientRect();
      let fraction = Math.max(0, Math.min(1, (clientX - rect.left - 4.25) / (rect.width - 8.5)));
      if (getComputedStyle(this.speedRange).direction === 'rtl') fraction = 1 - fraction;
      const seconds = Math.round(16 - fraction * 12);
      slideshow.duration = seconds * 1000;
      saveSlideshow(animate);
    }
    cancelSpeedAnimation() {
      cancelAnimationFrame(this.speedFrame);
      this.speedFrame = null;
      if (this.speedStep !== undefined) {
        this.speedRange.step = this.speedStep;
        this.speedStep = undefined;
      }
    }
    animateSpeed(target) {
      this.cancelSpeedAnimation();
      const start = Number(this.speedRange.value);
      if (reduced.matches || start === target) { this.speedRange.value = String(target); return; }
      this.speedStep = this.speedRange.step;
      this.speedRange.step = 'any';
      const started = performance.now();
      const tick = now => {
        if (!this.isConnected) { this.cancelSpeedAnimation(); return; }
        const progress = Math.min(1, (now - started) / 360);
        const eased = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        this.speedRange.value = String(start + (target - start) * eased);
        if (progress < 1) this.speedFrame = requestAnimationFrame(tick);
        else { this.cancelSpeedAnimation(); this.speedRange.value = String(target); }
      };
      this.speedFrame = requestAnimationFrame(tick);
    }
    revealSettings(visible, animate) {
      if (this.settingsVisible === visible) return;
      this.settingsVisible = visible;
      const panel = this.settings;
      if (!animate || reduced.matches) {
        this.settingsAnimation?.cancel();
        this.settingsAnimation = null;
        panel.inert = !visible;
        panel.hidden = !visible;
        return;
      }
      panel.inert = !visible;
      // Reverse the same timeline so interrupted selections retain their position.
      if (this.settingsAnimation) {
        this.settingsAnimation.playbackRate = visible ? 1 : -1;
        this.settingsAnimation.play();
        return;
      }
      panel.hidden = false;
      const height = getComputedStyle(panel).height;
      const animation = panel.animate([
        { height: '0px', marginBlockStart: '0px', opacity: 0, overflow: 'hidden', offset: 0 },
        { height, marginBlockStart: '18px', opacity: 1, overflow: 'hidden', offset: 1 }
      ], { duration: 280, easing: 'ease-in-out', fill: 'both' });
      this.settingsAnimation = animation;
      if (!visible) { animation.currentTime = 280; animation.playbackRate = -1; }
      animation.onfinish = () => {
        if (this.settingsAnimation !== animation) return;
        panel.hidden = !this.settingsVisible;
        this.settingsAnimation = null;
        animation.cancel();
      };
    }
    syncSlideshow(animate = false, animateVisibility = true) {
      if (!this.settings) return;
      this.revealSettings(desktop.matches && count === 1, desktop.matches && animateVisibility);
      this.speedPanel.toggleAttribute('data-collapsed', !slideshow.enabled);
      this.speedPanel.inert = !slideshow.enabled;
      this.speedRange.disabled = !desktop.matches || !slideshow.enabled || count !== 1;
      const target = 16 - slideshow.duration / 1000;
      if (animate && !this.speedRange.disabled) this.animateSpeed(target);
      else { this.cancelSpeedAnimation(); this.speedRange.value = String(target); }
      const text = this.durationOutput.dataset.format.replace('__seconds__', String(slideshow.duration / 1000));
      this.crossfadeText(this.durationPrevious, this.durationNumber, String(slideshow.duration / 1000), this.durationNumber.textContent !== '');
      this.speedRange.setAttribute('aria-valuetext', text);
    }
    sync(animate = true) {
      if (!this.buttons) return;
      const switchesDetail = (this.number.textContent === '1') !== (count === 1);
      this.crossfadeText(this.label.querySelector('[data-density-label-previous]'), this.label.querySelector('[data-density-label-current]'), count === 1 ? this.label.dataset.detail : this.label.dataset.plural, animate && !switchesDetail);
      if (animate && switchesDetail && !reduced.matches) {
        this.label.parentElement.getAnimations().forEach(animation => animation.cancel());
        this.label.parentElement.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in-out' });
      }
      for (const button of this.buttons) {
        const selected = Number(button.dataset.density) === count;
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
        button.dataset.filled = String(Number(button.dataset.density) <= count);
      }
      this.number.parentElement.hidden = count === 1;
      this.crossfadeText(this.previous, this.number, String(count), animate && !switchesDetail);
      this.syncSlideshow(false, animate);
    }
  }
  if (!customElements.get('rr-grid-density')) customElements.define('rr-grid-density', GridDensity);
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('product-card, product-list') || node.querySelector('product-list'))))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  function scheduleResponsiveFade() {
    updateAutoDensity(true);
  }
  desktop.addEventListener('change', () => {
    scheduleResponsiveFade();
    document.querySelectorAll('rr-grid-density').forEach(control => control.syncSlideshow(false, false));
    schedule();
  });
  tablet.addEventListener('change', () => {
    if (!desktop.matches) scheduleResponsiveFade();
  });
  fullscreen.addEventListener('change', () => updateAutoDensity());
  window.addEventListener('pageshow', () => { updateAutoDensity(); schedule(); });
  window.addEventListener('resize', () => {
    schedule();
    if (!manual) updateAutoDensity();
  }, { passive: true });
  document.fonts?.ready.then(schedule);
  document.addEventListener('rr:collection-cards-sorted', schedule);
  document.addEventListener('rr:collection-results-replaced', schedule);
  schedule();
})();
